<template>
  <div class="shadow-lg col-11 col-sm-11 col-md-8 col-lg-4 col-xl-4">
    <div class="upload-container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row col-12 p-2 pt-4"
      v-if="currentSteps == 1">
      <div class="l-container col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex align-items-start flex-column">
        <h3 class="mx-4 text-default text-poppins">Upload track to master</h3>

        <div class="decor-box w-100 mt-2 px-4">
          <FileDropZone type="track" acceptFile="audio" />
        </div>

        <div class="w-100 px-4 f-tile d-flex justify-content-between align-items-center" v-for="item in files"
          v-bind:key="item.id">
          <div class="file-details d-flex align-items-center">
            <img class="m-1 mr-3" src="../assets/folder.png" height="25" width="25" alt="folder" />
            <div>
              <p>{{ item.file.name }}</p>
              <div class="sub-text d-flex align-items-end">
                <p class="pr-4">{{ (item.file.size / 1024).toFixed(2) }} KB</p>
              </div>
            </div>
          </div>
          <div class="cp-auto">
            <img class="m-1" src="../assets/trash.png" height="20" width="20" alt="status" @click="() => {
              removeFile(item.file.name);
            }
              " />
          </div>

        </div>
        <div v-if="files.length > 0" class="input-box mb-2 w-100 d-flex justify-content-center">
          <input tabindex="0" class="w-100 mx-4 mt-3" :class="nameClass" @input="onNameChange" type="text"
            placeholder="Enter Song name..." />
        </div>

        <div v-if="name.length > 0" class="input-box mb-2 w-100 d-flex justify-content-end px-4">
          <button class="btn" :disabled="btnDisabled" :class="loadingBtnClass" @click="onUplaod">
            Submit
          </button>
        </div>
      </div>

      <!-- <div
        class="r-container w-100 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex flex-column justify-content-end align-items-center">
        <upload-tray type="track" />
        <div class="w-100 mr-4 my-4 d-flex justify-content-end">
          <button class="btn" :disabled="btnDisabled" :class="loadingBtnClass" @click="onUplaod">
            Submit
          </button>
        </div>
      </div> -->

    </div>
    <b-modal ref="progress-modal" class="progress-modal hide fade in" centered id="progress-modal" no-close-on-backdrop
      hide-header-close hide-header body-class="progress-modal-body" no-fade hide-footer :title="progressModalTitle">
      <div class="d-block w-100 p-4">
        <h3 class="uploading-text">
          Uploading {{ name }}
        </h3>
        <progress-bar :options="progressBarOptions" :value="progressValue" />
        <div class="uploading-text d-flex justify-content-end w-100">
          {{ speed }} MB/s
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomUploadBox from "@/components/CustomUploadBox.vue";
import FileDropZone from "./FileDropZone.vue";
import UploadTray from "@/components/UploadTray.vue";
import axios from "axios";
import { stringHasSpecialCharacters } from "@/utils/string-utils";

export default {
  props: ["categ"],
  mounted() { },
  data() {
    return {
      selected: "",
      allSelected: [],
      mixselected: "",
      files: [],
      name: "",
      newName: "",
      totalSteps: this.categ === "mastering" ? 1 : 2,
      currentSteps: 1,
      selectedclass: "pr-select",
      nameclass: "n-input",
      elements: this.$store.state.trackData.elementList,
      trackUrls: [],
      refUrls: [],
      error: 0,
      uploadError: 0,
      trackStatus: 0,
      disabledbtn: 0,
      // errors
      xhrError: 0,
      nameError: 0,
      signedRequest: "",
      // progress indicator
      totalUploadItems: 2,
      currentUploadItem: 1,
      progressModalTitle: "",
      progressValue: 0,
      timeStamp: 0,
      prevProgress: 0,
      speed: 0,
      progressBarOptions: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 420,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
    };
  },
  computed: {
    ...mapState(["apiEvents"], ["trackData"]),

    trackUploadStatus() {
      return this.$store.state.trackData.trackUploadStatus;
    },
    selectedClass() {
      return this.selectedclass;
    },
    nameClass() {
      return this.nameclass;
    },
    btnDisabled() {
      return this.disabledbtn ? true : false;
    },
    btnCurrentDisabled() {
      return this.$store.state.trackData.currentDataList.length > 0
        ? false
        : true;
    },

    getProgress() {
      return this.$store.state.trackData.uploadProgress;
    },

    loadingBtnClass() {
      return !this.trackStatus ? "a-track" : "a-track-disable";
    },
  },
  components: {
    UploadTray,
    CustomUploadBox,
    FileDropZone
  },
  methods: {
    removeFile(name) {
      this.$store
        .dispatch("trackData/removeTrackFile", { fileName: name })
        .then(() => { });
    },
    stepNext() {
      if (this.currentSteps < 2) {
        this.currentSteps++;
        this.popupDisplay();
      }
    },
    onNameChange(e) {
      this.name = e.target.value;
      if (stringHasSpecialCharacters(this.name)) {
        this.nameError = 1;
        this.disabledbtn = 1;
        this.nameclass = "inp-danger";
        this.error = 1;
      } else {
        this.nameError = 0;
        this.disabledbtn = 0;
        this.nameclass = "n-input";
      }
    },
    popupDisplay() {
      this.$swal.fire({
        title:
          "Upload your latest bounce of the song you are sending in for mix. We want to hear what you have been listening to but will use this to make sure the files you upload next matches when we prep for mix.",
        icon: "info",

        confirmButtonText: "Ok",
      });
    },
    stepBack() {
      this.currentSteps--;
    },

    createProject() {
      if (this.newName != "") {
        this.$store
          .dispatch("apiEvents/createNewProject", {
            projectName: this.newName,
            userId: localStorage.getItem("userId"),
          })
          .then(() => {
            this.newName = "";
            this.$store.dispatch("apiEvents/fetchProjectsByUserId", {
              id: localStorage.getItem("userId"),
            });
          });
      }
      //
    },
    async onUplaod() {
      if (
        this.name !== "" &&
        this.$store.state.trackData.currentDataList.length > 0
      ) {
        this.disabledbtn = 1;
        this.trackStatus = 0;
        await this.uploadS3Helper(this.name.toString());
      } else {
        if (this.name === "") {
          this.nameclass = "inp-danger";
          this.error = 1;
          this.disabledbtn = 0;
        }
      }
    },

    async uploadS3Helper(trackname) {
      const trackList = this.$store.state.trackData.currentDataList;
      const trackRefList = this.$store.state.trackData.currentRefList;

      this.$refs["progress-modal"].show();

      for (let i = 0; i < trackList.length; i++) {
        const filePathObj = await this.fileKeyPathGenerator(
          trackList[i].file,
          trackname,
          "Track"
        );
        try {
          const res = await this.generateS3Request(
            trackList[i].file,
            filePathObj.key
          );
          await this.uploadOnUrl(res.data.signedRequest, trackList[i].file);

          this.trackUrls.push({
            stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
            stemGroup: "",
            stemName: trackList[i].file.name,
          });
        } catch (error) {
          this.$refs["progress-modal"].hide();
          await this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });

          this.uploadError = 1;
          throw "exit";
        }
      }
      if (!this.uploadError) {
        try {
          await this.createTrackHelper();
        } catch (error) {
          throw "exit";
        }

        await this.useCredits(this.$props.categ);
      }
    },
    async uploadOnUrl(url, file) {
      this.timeStamp = Date.now();
      this.prevProgress = 0;
      this.progressValue = 0;
      let res;
      try {
        res = await axios.put(url, file, {
          headers: {
            "Content-Disposition": "attachment",
            "Content-Type": file.type,
          },
          maxContentLength: Infinity,
          onUploadProgress: (progress) => {
            let percentCompleted = Math.round(
              (progress.loaded * 100) / progress.total
            );
            let time = Date.now() - this.timeStamp;
            let percent = (percentCompleted - this.prevProgress) / 100;
            let chunk = percent * file.size;
            let speed = (chunk / 1024 / 1024 / (time / 1000)).toFixed(2);

            this.timeStamp = Date.now();
            this.prevProgress = percentCompleted;

            this.speed = speed;

            this.progressValue = percentCompleted;
          },
        });
      } catch (error) {
        throw error;
      }
      return res;
    },
    formattedDate() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async fileKeyPathGenerator(file, trackName, type) {
      const date = this.formattedDate();
      const fileExt = file.name.split(".").pop();
      const path =
        localStorage.getItem("mxdUserName") +
        `_${type}_` +
        "1" +
        "_" +
        file.name
          .replace("adlib", "adlibs")
          .split("#")
          .join("_")
          .split("&")
          .join("_")
          .split("?")
          .join("_")
          .split(".")
          .slice(0, file.name.split(".").length - 1)
          .toString()
          .split(" ")
          .join("-") +
        "." +
        fileExt;

      const key =
        localStorage.getItem("mxdUserName") +
        `${type === "Track" ? "" : "/References"}/` +
        date +
        "/" +
        trackName.split(" ").join("-") +
        "/" +
        path;
      return {
        key: key,
        path: path,
      };
    },
    async generateS3Request(file, key) {
      let url;
      try {
        url = await this.$store.dispatch("apiEvents/getS3Sig", {
          fileName: file.name,
          fileType: file.type,
          key: key,
        });
      } catch (error) {
        throw error;
      }
      return url;
    },
    async createTrackHelper() {
      const res = await this.$store.dispatch("trackData/createNewTrack", {
        userId: parseInt(localStorage.getItem("userId")),
        trackName: this.name.toString(),
        projectId:
          this.selected != ""
            ? this.$store.state.apiEvents.userProjects.find((item) => {
              return item.name === this.selected;
            }).id
            : 0,
        trackCategory: this.$props.categ,
        trackStyle: "Full",
        trackProject: this.selected,
        username: localStorage.getItem("mxdUserName"),
        trackFiles: this.trackUrls,
        refFiles: this.refUrls,
        elementGroup: this.$props.categ,
      });
      this.responseFunc(res);
    },
    async useCredits(trackType) {
      if (trackType == "track") {
        await this.$store.dispatch("apiEvents/useTrackCredit");
      } else if (trackType == "atmos") {
        await this.$store.dispatch("apiEvents/useAtmosCredit");
      } else if (trackType == "stereo") {
        await this.$store.dispatch("apiEvents/useStereoCredit");
      }
    },
    async responseFunc(res) {
      if (res.data.success) {
        await this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Track Uploaded",
          showConfirmButton: false,
          timer: 1500,
        });
        this.$router.push("../dashboard");
      } else {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    },
  },
  watch: {
    '$store.state.trackData.currentDataList': function () {
      this.files = this.$store.state.trackData.currentDataList
    }
  }
};
</script>

<style scoped>
.f-tile {
  border-radius: 7px;
  background-color: #ffffff;
}

.f-tile p {
  color: rgb(0, 0, 0);
  font-size: 12px;
  margin: 0 !important;
}

.sub-text p:nth-child(1) {
  font-size: 11px;
  color: rgb(92, 92, 92);
}

.sub-text p:nth-child(2),
.sub-text p:nth-child(3) {
  color: rgb(167, 167, 167) !important;
  font-size: 9px !important;
}

.upload-container {
  background-color: rgb(255, 255, 255);
  border-radius: 7px;
}

.n-input,
.pr-select,
.inp-danger,
.pr-new {
  border: 0px !important;
  font-size: 14px;
  padding: 8px !important;
  background-color: rgb(238, 238, 238);
  border-radius: 5px;
  border: 1px solid rgb(238, 238, 238);
}

.inp-danger {
  border: 1px solid rgb(255, 186, 186) !important;
  background-color: rgb(255, 223, 223);
}

.pr-select option {
  background-color: rgb(255, 255, 255);
  padding: 4px;
}

.btn-ap {
  background-color: #7dfcd5;
  width: 75px;
  height: 34px;
  margin: 0px !important;
  font-size: 14px;
}

.text-default {
  color: #303030;
  font-weight: bold
}

.text-poppins {
  font-family: 'Poppins', sans-serif !important;
}

.a-track {
  background-color: #26ffd4;
}

.a-track-disable {
  pointer-events: none;
  background-color: #cfcfcf;
}

.uploading-text {
  color: #202228;
  padding: 8px 0px 14px 0px;
}

#line-progress {
  border-radius: 4px;
}
</style>
